import { render, staticRenderFns } from "./SpecChatScreen.vue?vue&type=template&id=b6dd82c2&scoped=true&lang=pug&"
import script from "./SpecChatScreen.vue?vue&type=script&lang=js&"
export * from "./SpecChatScreen.vue?vue&type=script&lang=js&"
import style0 from "./SpecChatScreen.vue?vue&type=style&index=0&id=b6dd82c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dd82c2",
  null
  
)

export default component.exports